import React from 'react';
import Timeline, {
  TimelineHeaders,
  SidebarHeader,
  DateHeader
} from "react-calendar-timeline/lib";
import 'react-calendar-timeline/lib/Timeline.css';
import moment from 'moment';

class RoadmapTimeline extends React.PureComponent {
  render() {
    const {
      className = undefined,
      groups = [],
      items = [],
      onItemMove,
      onItemResize,
      onItemClick,
      onItemDoubleClick,
      onCanvasClick,
      onCanvasDoubleClick,
      mapGroups = (groups) => this.mapGroups(groups),
      mapItems = (items, groups) => this.mapItems(items, groups),
    } = this.props;

    const keys = {
      groupIdKey: "id",
      groupTitleKey: "title",
      groupRightTitleKey: "title",
      itemIdKey: "id",
      itemTitleKey: "title",
      itemDivTitleKey: "description",
      itemGroupKey: "group",
      itemTimeStartKey: "startDate",
      itemTimeEndKey: "endDate",
      groupLabelKey: "title"
    };

    if (items.length === 0) {
      return <div></div>;
    }

    return (
      <Timeline
        className={className}
        keys={keys}
        groups={mapGroups(groups)}
        items={mapItems(items)}
        itemsSorted
        itemTouchSendsClick={false}
        stackItems
        itemHeightRatio={0.75}
        showCursorLine
        canMove={false}
        canResize={false}
        defaultTimeStart={moment('20190601').toDate()}
        defaultTimeEnd={moment('20191201').toDate()}
        onItemMove={onItemMove}
        onItemResize={onItemResize}
        onItemClick={onItemClick}
        onItemDoubleClick={onItemDoubleClick}
        onCanvasClick={onCanvasClick}
        onCanvasDoubleClick={onCanvasDoubleClick}
      >
        <TimelineHeaders className="sticky">
          <SidebarHeader>
            {({ getRootProps }) => {
              return (
                <div {...getRootProps()}>
                </div>
              );
            }}
          </SidebarHeader>
          <DateHeader unit="primaryHeader" />
          <DateHeader />
        </TimelineHeaders>
      </Timeline>
    );
  }

  mapGroups(groups) {
    const {
      mapGroup = this.mapGroup
    } = this.props;
    return groups ? groups.map(mapGroup) : [];
  }

  mapGroup(group){
    return group;
  }

  mapItems(items, groups) {
    const {
      mapItem = this.mapItem
    } = this.props;
    return items ? items.map(i => mapItem(i, groups)) : [];
  }

  mapItem(item, groups) {
    return {
      ...item,
      startDate: moment(item.startDate),
      endDate: moment(item.endDate)
    };
  }
}

export default RoadmapTimeline;
